import { ChildEntity, CommonEntity }        from '$/entities/BaseEntity';
import { Verification, VerificationStatus } from '$/entities/verifications/Verification';
import { User, ProgressStatus }             from '$/entities/User';
import { BaseRole }                         from '$/entities/roles/BaseRole';

/**
 * Implementation of identity verification by manual verification by a Support person
 **/
@ChildEntity() @CommonEntity()
export class ManualVerification extends Verification {

	get additionalData() {
		return this.additionalDataValue as {
			roleId?: string;		// the role of the user that manually set the verification status of this user/role (if known)
		};
	}

	static createFrom(userOrRole: User | BaseRole) {
		const instance = new ManualVerification();

		if (!userOrRole) {
			return;
		}

		if (userOrRole instanceof BaseRole) {
			instance.role = userOrRole;
		}
		else if (userOrRole instanceof User) {
			instance.user = userOrRole;
		}

		instance.status = {
			[ProgressStatus.Approved] : VerificationStatus.Approved,
			[ProgressStatus.Rejected] : VerificationStatus.Rejected,
		}[userOrRole.verificationStatus];

		return instance;
	}

}
